import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'ui/i18n';

import { render_date, render_amount } from 'utils';

const OrderDetailsInfo = ({ details }) =>
	<div className="OrderDetailsInfo row">
		<div className="col-md-5 col-sm-5 col-xs-5">
			<table className="table">
				<tbody>
					<tr>
						<th>
							<FormattedMessage id="orderDetails.orderType" />
						</th>
						<td id="OrderDetailsInfo-tableCell-orderType">
							{details.type === null
								? ' '
								: <FormattedMessage
										id={`detailsstatus.type.${details.type}`}
										defaultMessage={details.type}
									/>}
						</td>
					</tr>

					<tr>
						<th>
							<FormattedMessage id="orderDetails.orderDate" />
						</th>
						<td id="OrderDetailsInfo-tableCell-orderDate">
							{render_date(details.date)}
						</td>
					</tr>

					<tr>
						<th>
							<FormattedMessage id="orderDetails.franchiseeNumber" />
						</th>
						<td id="OrderDetailsInfo-tableCell-franchiseeNumber">
							{details.franchisee_number}
						</td>
					</tr>

					<tr>
						<th>
							<FormattedMessage id="orderDetails.orderReference" />
						</th>
						<td id="OrderDetailsInfo-tableCell-poNumber">
							{details.po_number}
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div className="col-md-2 col-sm-2 col-xs-2" />

		<div className="col-md-5 col-sm-5 col-xs-5">
			<table className="table">
				<tbody>
					<tr>
						<th>
							<FormattedMessage id="orderDetails.totalOrderList" />
						</th>
						<td id="OrderDetailsInfo-tableCell-totalOrderList">
							{render_amount(details.totals.list)}
						</td>
					</tr>

					<tr>
						<th>
							<FormattedMessage id="orderDetails.totalOrderNet" />
						</th>
						<td id="OrderDetailsInfo-tableCell-totalOrderNet">
							{render_amount(details.totals.net)}
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>;

OrderDetailsInfo.propTypes = {
	details: PropTypes.object.isRequired,
};

export default OrderDetailsInfo;



// WEBPACK FOOTER //
// ./src/ui/components/OrderDetailsInfo/index.js